<template>

    <div class="homestay knowledge-base">

        <knowledge-nav />

        <div class="homestay__heading knowledge-base__heading">

            <svg width="793" height="106" viewBox="0 0 793 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M91.5127 21.8818H58.6523V110.988H32.2588V21.8818H0V1.50391H91.5127V21.8818Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M146.477 72.3379H132.19V110.988H105.797V1.50391H148.884C161.867 1.50391 172.019 4.38639 179.338 10.1514C186.657 15.9163 190.316 24.0625 190.316 34.5898C190.316 42.2096 188.762 48.526 185.654 53.5391C182.596 58.5521 177.784 62.6126 171.217 65.7207L194.076 109.86V110.988H165.803L146.477 72.3379ZM132.19 51.96H148.884C153.897 51.96 157.656 50.6566 160.163 48.0498C162.72 45.3929 163.998 41.7083 163.998 36.9961C163.998 32.2839 162.72 28.5993 160.163 25.9424C157.606 23.2354 153.847 21.8818 148.884 21.8818H132.19V51.96Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M271.524 90.5352H235.355L229.039 110.988H200.841L240.995 1.50391H265.809L306.264 110.988H277.916L271.524 90.5352ZM241.672 70.1572H265.208L253.402 32.1836L241.672 70.1572Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M408.828 110.988H382.585L343.784 42.8613V110.988H317.39V1.50391H343.784L382.51 69.6309V1.50391H408.828V110.988Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M485.073 81.8877C485.073 78.0277 483.694 75.0199 480.937 72.8643C478.23 70.7087 473.443 68.4779 466.575 66.1719C459.707 63.8659 454.092 61.6351 449.731 59.4795C435.544 52.5114 428.451 42.9365 428.451 30.7549C428.451 24.6891 430.205 19.3503 433.715 14.7383C437.274 10.0762 442.287 6.4668 448.754 3.91016C455.22 1.30339 462.489 0 470.56 0C478.431 0 485.474 1.40365 491.69 4.21094C497.956 7.01823 502.819 11.0286 506.278 16.2422C509.737 21.4056 511.466 27.321 511.466 33.9883H485.148C485.148 29.5267 483.77 26.0677 481.012 23.6113C478.305 21.1549 474.621 19.9268 469.959 19.9268C465.246 19.9268 461.512 20.9795 458.755 23.085C456.048 25.1403 454.694 27.7721 454.694 30.9805C454.694 33.7878 456.198 36.3444 459.206 38.6504C462.214 40.9062 467.502 43.2624 475.072 45.7188C482.642 48.125 488.858 50.7318 493.72 53.5391C505.551 60.3568 511.466 69.7562 511.466 81.7373C511.466 91.3122 507.857 98.8317 500.638 104.296C493.42 109.76 483.519 112.492 470.936 112.492C462.063 112.492 454.017 110.913 446.799 107.755C439.63 104.547 434.216 100.185 430.556 94.6709C426.947 89.1064 425.142 82.7148 425.142 75.4961H451.611C451.611 81.3613 453.115 85.6976 456.123 88.5049C459.181 91.262 464.118 92.6406 470.936 92.6406C475.298 92.6406 478.731 91.7132 481.238 89.8584C483.795 87.9535 485.073 85.2965 485.073 81.8877Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M597.036 67.375H554.475V110.988H528.082V1.50391H601.322V21.8818H554.475V47.0723H597.036V67.375Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M683.282 64.5928H641.774V90.6855H690.801V110.988H615.38V1.50391H690.952V21.8818H641.774V44.9668H683.282V64.5928Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M745.315 72.3379H731.028V110.988H704.634V1.50391H747.721C760.705 1.50391 770.856 4.38639 778.175 10.1514C785.494 15.9163 789.154 24.0625 789.154 34.5898C789.154 42.2096 787.6 48.526 784.492 53.5391C781.434 58.5521 776.621 62.6126 770.054 65.7207L792.914 109.86V110.988H764.64L745.315 72.3379ZM731.028 51.96H747.721C752.734 51.96 756.494 50.6566 759 48.0498C761.557 45.3929 762.835 41.7083 762.835 36.9961C762.835 32.2839 761.557 28.5993 759 25.9424C756.444 23.2354 752.684 21.8818 747.721 21.8818H731.028V51.96Z" fill="#F0F5FD" fill-opacity="0.1"/>
            </svg>


            <div class="homestay__heading-title knowledge-base__heading-title">
               {{$store.getters.t('homestays_title')}}
            </div>

        </div>

        <div class="homestay__grid knowledge-base__grid">

            <div class="container">
                <div class="row">

                    <div class="col-md-12 col-lg-3">

                        <!-- start aside -->
                        <aside class="sidebar product--sidebar" @click="filterToggle">

                            <div class="product--sidebar-wrapper">

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse1" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse1">
                                        <h4>{{$store.getters.t('homestays_filter_city')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse1">
                                        <div class="card-content">
                                            <div class="form-group mt-2">
                                                <label for="city_id">{{$store.getters.t('donors_locality')}}</label>
                                                <div class="" style="position:relative;">
                                                    <input v-model="citySearch" class="form-control city-filter" autocomplete="off" id="city_id" :placeholder="$store.getters.t('homestay_start_typing_locality')"/>
                                                    <div class="search-result" v-if="cities.length">
                                                        <div class="city-item" v-for="city in cities" @click="setCityId(city.id, city.name)">{{city.name}}</div>
                                                    </div>
                                                    <div class="search-result" v-if="!cities.length && citySearch && citySearch !== citySelected">
                                                        <div class="city-item">{{$store.getters.t('homestays_store_form_nothing_found')}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse2" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse2">
                                        <h4>{{$store.getters.t('facilities_filter_tariff')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse2">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="chargeCategory === 'paid_for'"
                                                           @change="dynamicFilter('chargeCategory','paid_for', $event)" id="charge_filter_paid" class="">
                                                    <label for="charge_filter_paid">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_paid')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="chargeCategory === 'free'"
                                                           @change="dynamicFilter('chargeCategory','free', $event)" id="charge_filter_free" class="">
                                                    <label for="charge_filter_free">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_free')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse3" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse3">
                                        <h4>{{$store.getters.t('homestays_filter_reception')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse3">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="receptionStatus === 'open'"
                                                           @change="dynamicFilter('receptionStatus','open', $event)" id="reception_filter_open" class="">
                                                    <label for="reception_filter_open">
                                                        <span class="square"></span>{{$store.getters.t('homestays_store_form_reception_open')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="receptionStatus === 'closed'"
                                                           @change="dynamicFilter('receptionStatus','closed', $event)" id="reception_filter_closed" class="">
                                                    <label for="reception_filter_closed">
                                                        <span class="square"></span>{{$store.getters.t('homestays_store_form_reception_closed')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse4" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse4">
                                        <h4>{{$store.getters.t('homestays_filter_type')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse4">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           v-model="typeFilter" id="type_filter_apartment" value="apartment" class="">
                                                    <label for="type_filter_apartment">
                                                        <span class="square"></span>{{$store.getters.t('homestays_type_apartment')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           v-model="typeFilter" id="type_filter_enclosure" value="enclosure" class="">
                                                    <label for="type_filter_enclosure">
                                                        <span class="square"></span>{{$store.getters.t('homestays_type_enclosure')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse5" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse5">
                                        <h4>{{$store.getters.t('homestays_filter_days')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse5">
                                        <div class="card-content">
                                            <div class="form-group mt-2">
                                                    <input type="number" min="1"  pattern="\d+" v-model="duration" class="form-control" autocomplete="off" id="duration" :placeholder="$store.getters.t('homestay_enter_days_count')"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <button id="sidebar-toggle" @click.prevent="sidebarFilterToggle">

                                <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0.882353C0 0.395037 0.466882 0 1.04278 0H21.8984C22.4743 0 22.9412 0.395037 22.9412 0.882353C22.9412 1.36967 22.4743 1.76471 21.8984 1.76471H1.04278C0.466882 1.76471 0 1.36967 0 0.882353Z" fill="white"/>
                                    <path d="M7.05884 9.7059C7.05884 9.21859 7.36273 8.82355 7.73757 8.82355H15.2036C15.5785 8.82355 15.8824 9.21859 15.8824 9.7059C15.8824 10.1932 15.5785 10.5883 15.2036 10.5883H7.73757C7.36273 10.5883 7.05884 10.1932 7.05884 9.7059Z" fill="white"/>
                                    <path d="M4.41187 5.2941C4.41187 4.80679 4.89809 4.41174 5.49784 4.41174H17.4435C18.0433 4.41174 18.5295 4.80679 18.5295 5.2941C18.5295 5.7814 18.0433 6.17645 17.4435 6.17645H5.49784C4.89809 6.17645 4.41187 5.7814 4.41187 5.2941Z" fill="white"/>
                                    <path d="M9.88229 13.2353C9.29761 13.2353 8.82349 13.6303 8.82349 14.1176C8.82349 14.605 9.29761 15 9.88229 15H13.0588C13.6435 15 14.1176 14.605 14.1176 14.1176C14.1176 13.6303 13.6435 13.2353 13.0588 13.2353H9.88229Z" fill="white"/>
                                </svg>


                            </button>


                        </aside>
                        <!-- end aside -->


                    </div>

                    <div class="col-md-12 col-lg-9">

                        <div class="homestay__store knowledge-base__store">
                            <a href="/auth/login" class="btn auto-help__store-btn knowledge-base__store-btn" v-if="!user">
                                {{$store.getters.t('facilities_add_ad')}}
                            </a>
                            <button class="btn homestay__store-btn knowledge-base__store-btn" v-else
                                    @click.prevent="showStoreForm = !showStoreForm">
                                {{$store.getters.t('homestays_help_button')}}
                            </button>

                            <transition name="slide">
                                <store-form @storeForm="refreshList" type="STORE" v-show="showStoreForm"/>
                            </transition>

                        </div>

                        <template v-if="!loaded">
                            <div class="homestay__item knowledge-base__item knowledge-base__item--empty d-flex">
                                <div class="LoaderBalls">
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div v-if="list.length">

                                <div class="homestay__item" v-for="(item, idx) in list">
                                    <card-horizontal @deleted="getHomestay" :user="user" :pets="userPets" :homestay="item" :index="idx" :key="idx" />
                                </div>

                                <div class="row" v-if="pageCount > 1">
                                    <div class="col-md-12">
                                        <div class="pagination-area pull-right">
                                            <nav class="navigation pagination" role="navigation">
                                                <div class="nav-links">
                                                    <paginate
                                                        v-model="page"
                                                        :page-count="pageCount"
                                                        :click-handler="paginateClickCallback"
                                                        :prev-text="''"
                                                        :next-text="''"
                                                        :container-class="'className'"
                                                        :page-class="'page-numbers'"
                                                        :page-link-class="''"
                                                        :active-class="'current'"
                                                        :prev-class="'prev page-numbers'"
                                                        :prev-link-class="'lnr lnr-arrow-left'"
                                                        :next-class="'next page-numbers'"
                                                        :next-link-class="'lnr lnr-arrow-right'"
                                                    >
                                                    </paginate>
                                                </div>
                                            </nav>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-else>
                                <div class="homestay__item knowledge-base__item knowledge-base__item--empty d-flex">
                                    {{$store.getters.t('facilities_list_empty')}}
                                </div>
                            </div>

                        </template>

                    </div>

                </div>
            </div>


        </div>


    </div>
</template>

<script>


import {paginationScrollTo} from '../helpers/helpers'

import KnowledgeNav from "../KnowledgeBase/KnowledgeNav";
import CardHorizontal from "./CardHorizontal";
import StoreForm from "./StoreForm";
export default {
    name: "Homestay",
    components:{
        StoreForm,
        KnowledgeNav,
        CardHorizontal
    },
    props: ['homeData'],
    data(){
        return{
            appRoutes: null,
            pageCount: 0,
            page: 1,
            showStoreForm: false,
            citySearch: null,
            citySelected: null,
            selectedCityId: null,
            cities: [],

            receptionStatus: null,
            chargeCategory: null,
            duration: null,
            typeFilter: [],

            userPets: [],

            list: [],
            loaded: true,
        }
    },

    created() {
        this.appRoutes = window.appRoutes;
    },

    mounted(){
        this.loaded = false
        this.getUserPets()
        this.getHomestay()
    },
    watch: {
        list(){
            this.loaded = false
            setTimeout(()=>{
                this.loaded = true
            }, 1000)
        },

        citySearch(value) {
            if (!value) {
                this.citySelected = null;
                this.cities = [];
                this.selectedCityId = null;
                return false;
            }

            if (value !== this.citySelected) {
                this.searchCities();
            }
        },

        chargeCategory(){
            this.getHomestay(true);
        },

        receptionStatus(){
            this.getHomestay(true);
        },
        selectedCityId() {
            this.getHomestay(true);
        },
        typeFilter() {
            this.getHomestay(true);
        },
        duration() {
            if(this.duration < 0) return this.duration = null

            this.getHomestay(true);
        },

    },

    computed:{

        user(){
          return this.$store.getters.getUserData;
        }

    },

    methods:{

        refreshList(){
          this.getHomestay(true)
        },

        dynamicFilter(selfObjectParam, filter, event){

            let checked = event.target.checked

            if(!checked) return this[selfObjectParam] = null
            return this[selfObjectParam] = filter
        },

        getUserPets(){

            if (!this.user) return

            let url = `/api/user/pets-list`

            axios(url)
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.userPets = response.data
                    }

                })
                .catch()

        },

        paginateClickCallback(pageNum) {
            this.page = pageNum;

            paginationScrollTo('.homestay__grid')

            this.getHomestay();
        },


        getHomestay(resetPage){
            let url = `/api/homestays`,
                duration = (typeof +this.duration === 'number' && +this.duration <= 0) ? null : this.duration

            if(resetPage){
                this.page = 1
            }


            axios.get(url,{
                params: {
                    page: this.page,
                    city_id: this.selectedCityId,
                    charge_category: this.chargeCategory,
                    reception_status: this.receptionStatus,
                    per_page: 5,
                    type: !this.typeFilter.length ? null : (this.typeFilter.length > 1 ? null : this.typeFilter[0]) ,
                    duration: duration
                }
            })
                .then(response => {
                    response = response.data

                    if(response.success){

                        this.list = response.data
                        this.page = response.meta.current_page
                        this.pageCount = response.meta.last_page


                    }

                })
                .catch(error => {
                    error = error.response.data


                    console.log('error')


                })

        },


        setCityId(cityId, cityName) {
            this.selectedCityId = cityId;
            this.citySearch = cityName;
            this.citySelected = cityName;
            this.cities = [];
        },

        searchCities(store = false) {
            let self = this;
            let url = '/' + self.appRoutes['geo.searchCities'],
                params = {
                    searchValue: self.citySearch
                }


            if(store) {
                params = {
                    searchValue: self.storeForm.citySearch
                }
            }

            axios.get(url, {params : params})
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        if(store){return self.storeForm.cities = response.cities}
                        self.cities = response.cities
                    } else {
                        alert(this.$store.getters.t('common_error_reload'));
                    }
                })
                .catch((error) => {

                })
                .then();
        },

        sidebarFilterToggle(){
            let productFilter = document.querySelector('.product--sidebar');
            let body = document.querySelector('body');
            productFilter.classList.toggle('product-sidebar--open');
            body.classList.toggle('product-sidebar--open');
        },

        filterToggle(e){
            if(window.matchMedia("min-width: 992px").matches) return

            let filterWrapper = document.querySelector('.product--sidebar-wrapper');
            let filterBtn = document.getElementById('sidebar-toggle');

            if(!filterWrapper.contains(e.target) && !filterBtn.contains(e.target)){
                let productFilter = document.querySelector('.product--sidebar');
                let body = document.querySelector('body');

                productFilter.classList.remove('product-sidebar--open');
                body.classList.remove('product-sidebar--open');
                return;

            }

        }
    }
}
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
.slide-enter-active {
    -moz-transition-duration: 0.4s;
    -webkit-transition-duration: 0.4s;
    -o-transition-duration: 0.4s;
    transition-duration: 0.4s;
    -moz-transition-timing-function: ease;
    -webkit-transition-timing-function: ease;
    -o-transition-timing-function: ease;
    transition-timing-function: ease;
}

.slide-leave-active {
    -moz-transition-duration: 0.4s;
    -webkit-transition-duration: 0.4s;
    -o-transition-duration: 0.4s;
    transition-duration: 0.4s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
    max-height: 1000px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}


.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        // .LoaderBalls__wrapper__item
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}

@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}


.homestay{


    &__item{

        &--empty{
            text-align: center;
            justify-content: center;
            align-items: center;
            font-size: 22px;
            line-height: 26px;
            padding: 24px 40px 26px 30px;
            background: #fff;
            border-radius: 5px;
            box-shadow: 0px 0px 2px rgb(0 0 0 / 10%);
            min-height: 200px;
        }
    }


}

@media screen and(max-width: 768px){

    .product--sidebar .sidebar-card .card-title .lnr{
        right: -10px;
    }


}



</style>
<style lang="scss">

.homestay{

    &__item{
        .card-horizontal__user-photo span{
            background: #2E76E4;
        }
    }


}


</style>
